import { api } from "../app/endpoints";
import { translateOneItem } from "./helpers/service-helper";

export const fetchSEO = (page) =>
  fetch(api.seo(page))
    .then((res) => res.json())
    .then((data) => data)
    .then(translateOneItem)
    .then(({ title, description }) => ({ title, description }));
